/**
 * Reveals elements marked with [data-reveal-root] once they enter the viewport, by adding
 * an `is-revealed` class that the matching CSS in base.css transitions on. Skips straight to
 * the revealed state when the browser lacks IntersectionObserver support or the visitor has
 * prefers-reduced-motion enabled.
 */

function revealNow(roots) {
  for (const root of roots) {
    root.classList.add('is-revealed');
  }
}

function observeReveal(roots) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  for (const root of roots) {
    observer.observe(root);
  }
}

function initScrollReveal() {
  const roots = document.querySelectorAll('[data-reveal-root]:not(.is-revealed)');
  if (!roots.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealNow(roots);
    return;
  }

  observeReveal(roots);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveal);
} else {
  initScrollReveal();
}

// Re-scan when the theme editor swaps section markup.
document.addEventListener('shopify:section:load', initScrollReveal);
